import { render, staticRenderFns } from "./order-price-list.vue?vue&type=template&id=48c3e832&scoped=true"
import script from "./order-price-list.vue?vue&type=script&lang=js"
export * from "./order-price-list.vue?vue&type=script&lang=js"
import style0 from "./order-price-list.vue?vue&type=style&index=0&id=48c3e832&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c3e832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c3e832')) {
      api.createRecord('48c3e832', component.options)
    } else {
      api.reload('48c3e832', component.options)
    }
    module.hot.accept("./order-price-list.vue?vue&type=template&id=48c3e832&scoped=true", function () {
      api.rerender('48c3e832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/order-price-list.vue"
export default component.exports